/*globals STATIC_URL*/
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getCookie,
  rupees,
  isInternetExporerBrowser,
  isIOS_Device,
  isWindowsPhoneDevice,
  isIOS_Webview,
  isAndroidWebview,
} from 'config/utils';
import ia from 'config/Analytics';
import Rupee from 'views/Rupee';
import Icon from 'views/Icon';
import { Row, Columns } from 'views/Grid';
import {
  getEMIAmount,
  getTotalEMIAmount,
  getMatchingPaymentOption,
} from '../utils/FinalizePurchaseUtils';
import classNames from 'classnames';
import scrollController from '../decorators/ScrollController';
import ConvenienceFeeNote from './convenience-fee/ConvenienceFeeNote';
import TrustIcons from './finalize/TrustIcons';
import TnCText from './finalize/TnCText';
import SavedCards from './finalize/SavedCards';
import {
  handleResetSelectedPaymentMode,
  handleSelectPaymentOption,
  handleSelectBank,
  handleSelectWallet,
  handleBankPaymentRequest,
  handleWalletPaymentRequest,
  handleChangeEMICardProvider,
  handleChangeEMITenure,
  handleSubmitEMIForm,
  handleChangeSelectedEMIProvider,
  handleHideLoader,
  handleChangeUPIHandle,
  handleSubmitUPI,
} from '../actions/FinalizePurchaseActions';

import {
  handleAwaitingPaymentCompletion,
} from '../actions/SettingsActions';

import {
  eventMethod,
  messageEvent,
} from 'utils/EventUtils';

import root from 'window-or-global';

import { Form, FormFieldWithLabel as FormField, FormFieldWrapper as FormFieldsWrapper } from 'views/FormComponents';
const LOADER_CLASS = 'loading--wrapper';

const redirectToPostPurchasePageAfterPaymentAttempt = (windowObject) => {
  root[eventMethod](messageEvent, function (e: Event) {
    const {
      origin,
      data,
      data: {
        name,
      },
    } = e;

    // Accept messages from same origin only.
    if (origin != root.location.origin) {
      return;
    }

    switch(name) {
      case 'redirect': {
        const {
          url,
          isExternalUrl,
        } = data;
        if (url && root.location) {
          // For Setting up loader for online-store and im-embed
          if (root.parent !== root) {
            root.parent.postMessage('changingIframeUrl', '*');
          }

          if (isExternalUrl) {
            root.parent.location.href = url;
          } else {
            root.location.href = url;
          }

          if (windowObject && !windowObject.closed) {
            windowObject.close();
          }
        }
        return;
      }
      default: {
        return;
      }
    }
  });
};

let isFrameHeightChangeListenerAdded = false;

class FinalizePurchase extends React.Component {
  onSelectEMIOption (months, emiAmount) {
    this.props.handleChangeEMITenure(months, emiAmount);
    this.props.handleSubmitEMIForm();
  }

  openNewWindowAndGetTarget () {
    const width = 900, height = 600;

    const left = (root.screen.width / 2) - (width / 2);
    const top = (root.screen.height / 2) - (height / 2);
    return {
      windowObject: root.open('', 'Instamojo_Payment_Window', `toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=${width},height=${height},left=${left},top=${top}`),
      windowName: 'Instamojo_Payment_Window',
    };
  }

  getShouldSubmitInNewWindow () {
    return !(
      isInternetExporerBrowser ||
      isWindowsPhoneDevice ||
      isIOS_Device || // Temporary Disable for all IOS Devices
      // isIOS_Webview ||
      isAndroidWebview
    );
  }

  componentWillReceiveProps (nextProps) {
    const {
      isBankPaymentRequestSubmitted: prevIsBankPaymentRequestSubmitted,
      isWalletPaymentRequestSubmitted: prevIsWalletPaymentRequestSubmitted,
    } = this.props.finalizePurchase;

    const shouldSubmitInNewWindow = this.getShouldSubmitInNewWindow();

    const {
      isBankPaymentRequestSubmitted,
      isWalletPaymentRequestSubmitted,
    } = nextProps.finalizePurchase;

    if (!prevIsBankPaymentRequestSubmitted && isBankPaymentRequestSubmitted && this.refs.bankFormSubmit) {
      if (shouldSubmitInNewWindow) {
        const {
          windowObject,
          windowName,
        } = this.openNewWindowAndGetTarget();
        this.refs.bankFormSubmit.target = windowName;
        this.refs.bankSubmitButton.disabled = true;
        redirectToPostPurchasePageAfterPaymentAttempt(windowObject);
      }
      this.refs.bankFormSubmit.submit();
    }

    if (!prevIsWalletPaymentRequestSubmitted && isWalletPaymentRequestSubmitted && this.refs.walletFormSubmit) {
      if (shouldSubmitInNewWindow) {
        const {
          windowObject,
          windowName,
        } = this.openNewWindowAndGetTarget();
        this.refs.walletFormSubmit.target = windowName;
        this.refs.walletSubmitButton.disabled = true;
        redirectToPostPurchasePageAfterPaymentAttempt(windowObject);
      }
      this.refs.walletFormSubmit.submit();
    }
  }

  componentDidMount () {
    const matchingPaymentOption = getMatchingPaymentOption(this.props.finalizePurchase.paymentOptions);
    const {
      paymentOptions,
      order,
    } = this.props.finalizePurchase;
    if (this.props.isFinalizeFormOpen && matchingPaymentOption) {
      this.props.handleSelectPaymentOption(matchingPaymentOption);
    }
    ia.sendEvent('Viewed Payment Options', {
      'mode_list': Object.keys(paymentOptions).map(option => paymentOptions[option].name),
      'seller_username': this.props.username,
      'order_id': order,
    });
  }

  componentDidUpdate () {
    const frameRef = this.scIframeRef || this.ccIframeRef || this.emiIframeRef;
    if (frameRef && !isFrameHeightChangeListenerAdded) {
      isFrameHeightChangeListenerAdded = true;
      root[eventMethod](messageEvent, (e) => {
        const {
          data: {
            name,
            height,
            url,
            isExternalUrl,
          },
        } = e;

        switch(name) {
          case 'iframeHeight': {
            frameRef.height = height;
            frameRef.style.maxHeight = `${height}px`;
            return;
          }
          case 'redirect': {
            if (url && root.location) {
              // For Setting up loader for online-store and im-embed
              if (root.parent !== root) {
                root.parent.postMessage('changingIframeUrl', '*');
              }

              if (isExternalUrl) {
                root.parent.location.href = url;
              } else {
                root.location.href = url;
              }
            }
            return;
          }
          case 'isAwaitingPaymentCompletion': {
            this.props.handleAwaitingPaymentCompletion();
            return;
          }
          default: {
            return;
          }
        }
      });
    } else if (!frameRef) {
      isFrameHeightChangeListenerAdded = false;
    }

    const {
      selectedPaymentMode,
      selectedSavedCard,
      isSelectedPaymentModeLoading,
      isEMIFormSubmitted,
    } = this.props.finalizePurchase;

    if (isSelectedPaymentModeLoading &&
      (selectedPaymentMode === 'card' ||
        selectedPaymentMode === 'saved_cards' ||
        (selectedPaymentMode === 'emi' && isEMIFormSubmitted)
      )
    ) {
      if (this.ccIframeRef) {
        // selected CC/DC as payment mode.
        this.ccIframeRef.onload = () => {
          this.props.handleHideLoader();
        };
      }
      if (this.emiIframeRef) {
        this.emiIframeRef.onload = () => {
          this.props.handleHideLoader();
        };
      }
      if (this.scIframeRef) {
        this.scIframeRef.onload = () => {
          this.scIframeRef.contentWindow.postMessage(selectedSavedCard, '*');
          this.props.handleHideLoader();
        };
      }
    }
  }

  renderWalletGrid ({ wallet, paymentOption }) {
    const { selectedWalletId } = this.props.finalizePurchase;
    return (
      <Columns key={wallet.id} className="small-6 grid__item end" style={{ height: '74px' }}>
        <div onClick={() => this.props.handleSelectWallet({
            walletId: wallet.id,
            paymentOption,
          })}
          className={classNames('grid__item--unit soft-half--sides', {
            'bank-selected': wallet.id === selectedWalletId,
          })}
          >
          <img
            src={wallet.image}
            alt={wallet.name}
            title={wallet.name}
            style={{ display: 'block', width: '100%' }} />
        </div>
      </Columns>
    );
  }

  renderBankGrid ({ bank, paymentOption }) {
    const { selectedBankId } = this.props.finalizePurchase;
    return (
      <Columns key={bank.id} className="small-6 grid__item end">
        <div onClick={() =>
            this.props.handleSelectBank({
              bankId: bank.id,
              paymentOption,
            })
          }
          className={classNames( 'grid__item--unit', {
            'bank-selected': bank.id === selectedBankId,
          })}
          >
          <div style={{ height: '40px', display: 'table', width: '100%' }}>
            <div style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>
              <span className={`banks-sprite banks-bank-${bank.id}`} style={{ verticalAlign: 'middle' }}></span>
              <span className="bank-list__bank-name">{bank.name}</span>
            </div>
          </div>
        </div>
      </Columns>
    );
  }

  renderBankOption (bank) {
    return (
      <option key={bank.id} value={bank.id}>{bank.name}</option>
    );
  }

  renderSelectedPaymentModeLoading () {
    return (
      <div>
        <div className="loading--animation"></div>
        <p>Connecting to secure servers...</p>
      </div>
    );
  }

  renderSelectedPaymentModeWithLoading (isSelectedPaymentModeLoading, Component) {
    return (
      <div className={isSelectedPaymentModeLoading ? LOADER_CLASS : null}>
        { isSelectedPaymentModeLoading
          ? this.renderSelectedPaymentModeLoading() : null }
        <div className="loading--content">
          {Component}
        </div>
      </div>
    );
  }

  _renderNB_FinalSubmissionForm (submissionUri) {
    const { selectedBankId } = this.props.finalizePurchase;

    return (
      <form ref="bankFormSubmit" action={submissionUri} method="POST" target="_parent">
        <input type="hidden" name="csrfmiddlewaretoken" value={getCookie('csrftoken')}/>
        <input type="hidden" name="bank" value={selectedBankId} />
      </form>
    );
  }

  renderSelectedPaymentMode (selectedPaymentOption) {
    const { type } = selectedPaymentOption;
    const {
      isMobileDevice,
      isSelectedPaymentModeLoading,
      selectedSavedCard,
    } = this.props.finalizePurchase;

    const shouldSubmitInNewWindow = this.getShouldSubmitInNewWindow();

    const termsTextStyles = { marginTop: isMobileDevice ? -7 : -14, marginBottom: '1rem' };

    switch (type) {
      case 'card': {
        const { submissionUri } = selectedPaymentOption;
        return (
          this.renderSelectedPaymentModeWithLoading(
            isSelectedPaymentModeLoading,
            <div>
              <iframe
                className="animate-iframe--max-height"
                ref={(ref) => {this.ccIframeRef = ref;}}
                src={`${submissionUri}newWindow=${shouldSubmitInNewWindow}`}
                height={292}
                width="100%"
                frameBorder="0"
                scrolling="no">
              </iframe>
              <TnCText styles={termsTextStyles} />
            </div>
          )
        );
      }

      case 'nb': {
        const { nbList, nbGridList, totalAmount } = selectedPaymentOption;
        const { selectedBankId, errors } = this.props.finalizePurchase;

        return (
          this.renderSelectedPaymentModeWithLoading(
            isSelectedPaymentModeLoading,
            <div>
              {this._renderNB_FinalSubmissionForm(selectedPaymentOption.submissionUri)}
              <Form onSubmit={e => {e.preventDefault(); this.props.handleBankPaymentRequest();}}>
                <FormFieldsWrapper>
                  <FormField errors={errors.selectedBank}>
                    <Row className="banks--grid soft--sides">
                      { nbGridList.map(bank =>
                          this.renderBankGrid({
                            bank, paymentOption: selectedPaymentOption,
                          })
                        )
                      }
                    </Row>

                    <select
                      value={selectedBankId}
                      onChange={e =>
                        this.props.handleSelectBank({
                          bankId: Number(e.target.value),
                          paymentOption: selectedPaymentOption,
                        })
                      }>
                      <option value="">Choose another Bank</option>
                      { nbList.map(bank => this.renderBankOption(bank)) }
                    </select>
                  </FormField>

                  <FormField>
                    <input
                      ref="bankSubmitButton"
                      className="btn-block btn-green"
                      style={{ marginBottom: 7 }}
                      type="submit"
                      value={`Checkout Rs. ${rupees(totalAmount)}`}/>
                    <TnCText />
                  </FormField>
                </FormFieldsWrapper>
              </Form>
            </div>
          )
        );
      }

      case 'emi': {
        const { emiList, submissionUri, totalAmount } = selectedPaymentOption;
        const {
          selectedEMICardProvider,
          selectedEMITenure,
          isEMIFormSubmitted,
          emiAmount,
        } = this.props.finalizePurchase;

        const emiIframeUriWithParams = `${submissionUri}&is_emi=true&emi_tenure=${selectedEMITenure}&emi_bank=${selectedEMICardProvider}`;
        const EMISummaryRowClasses = 'flex-space-between soft-half border-grey--bottom flush--bottom';

        return (
          <div>
            { isEMIFormSubmitted ?
              this.renderSelectedPaymentModeWithLoading(
                isSelectedPaymentModeLoading,
                <div>
                  <div className="rounded border-grey push--bottom">
                    <p className={`${EMISummaryRowClasses} background-white rounded--top`}>
                      <span>{emiList[selectedEMICardProvider].name}</span>
                      <span><a onClick={() => this.props.handleChangeSelectedEMIProvider()}>Change</a></span>
                    </p>
                    <p className={EMISummaryRowClasses}>
                      <span className="text-light-grey">Duration</span>
                      <span>{selectedEMITenure} months</span>
                    </p>
                    <p className={EMISummaryRowClasses}>
                      <span className="text-light-grey">Interest</span>
                      <span>{emiList[selectedEMICardProvider].rates[selectedEMITenure]}% p.a.</span>
                    </p>
                    <p className={`${EMISummaryRowClasses} borderless--bottom`}>
                      <span className="text-light-grey">Installments</span>
                      <span><Rupee value={emiAmount} /></span>
                    </p>
                  </div>
                  <iframe
                    className="animate-iframe--max-height"
                    ref={(ref) => {this.emiIframeRef = ref;}}
                    src={`${emiIframeUriWithParams}&newWindow=${shouldSubmitInNewWindow}`}
                    height={292}
                    width="100%"
                    frameBorder="0"
                    scrolling="no"></iframe>
                  <TnCText styles={termsTextStyles} />
                </div>
              )
              :
              <Form>
                <FormFieldsWrapper>
                  <FormField label="Select your Credit Card Provider">
                    <select value={selectedEMICardProvider} onChange={e =>
                       this.props.handleChangeEMICardProvider({
                         bankKey: e.target.value,
                         paymentOption: selectedPaymentOption,
                       })}>
                      { Object.keys(emiList).map(bankKey => {
                        return <option key={bankKey} value={bankKey}>{emiList[bankKey].name}</option>;
                      })}
                    </select>
                  </FormField>
                  <FormField label="Select an EMI option">
                    { Object.keys(emiList[selectedEMICardProvider].rates).map(months => {
                      const rate = emiList[selectedEMICardProvider].rates[months];
                      const emiAmount = getEMIAmount(totalAmount, rate / 1200, months);
                      const totalEmiAmount = getTotalEMIAmount(emiAmount, months);
                      return (
                        <Row
                          key={`${selectedEMICardProvider}_${months}`}
                          onClick={() => this.onSelectEMIOption(months, emiAmount)}
                          className="flush--sides hard--sides pointer card soft--bottom push--bottom"
                          style={{ borderColor: '#3B96E0' }}
                          >
                          <Columns className="small-10">
                            <div>
                              <Rupee value={emiAmount} />{` x ${months} Months`}
                            </div>
                            <div className="text-small">
                              Total <Rupee value={totalEmiAmount} /> {`@${rate}%`}
                            </div>
                          </Columns>
                          <Columns className="small-2 soft-half--top text-right soft-half--right">
                            <Icon className="arrows-1_minimal-right sm text-hyperlink"/>
                          </Columns>
                        </Row>
                      );
                    })}
                  </FormField>
                </FormFieldsWrapper>
              </Form>
            }
          </div>
        );
      }

      case 'wallet': {
        const { walletList, submissionUri, totalAmount } = selectedPaymentOption;
        const { errors, selectedWalletId } = this.props.finalizePurchase;
        return (
          this.renderSelectedPaymentModeWithLoading(
            isSelectedPaymentModeLoading,
            <div>
              {/* {this.renderPromotionBanner()} */}
              <form ref="walletFormSubmit" action={submissionUri} method="POST" target="_parent">
                <input type="hidden" name="csrfmiddlewaretoken" value={getCookie('csrftoken')}/>
                <input type="hidden" name="wallet" value={selectedWalletId} />
              </form>
              <Form onSubmit={(e) => {e.preventDefault(); this.props.handleWalletPaymentRequest();}}>
                <FormFieldsWrapper>
                  <FormField errors={errors.selectedWallet} className="hard--bottom">
                    <Row className="banks--grid soft--sides">
                      { walletList.map(wallet =>
                          this.renderWalletGrid({
                            wallet,
                            paymentOption: selectedPaymentOption,
                          })
                        )
                      }
                    </Row>
                  </FormField>

                  <FormField className="hard--bottom">
                    <input
                      ref="walletSubmitButton"
                      className="btn-block btn-green"
                      style={{ marginBottom: 7 }}
                      type="submit"
                      value={`Checkout Rs. ${rupees(totalAmount)}`}/>
                    <TnCText />
                  </FormField>
                </FormFieldsWrapper>
              </Form>
            </div>
          )
        );
      }

      case 'upi': {
        const {
          upiHandle, isUPIRequestSubmitted, isUPIRequestSubmitting,
          upiHandleError, upiBank,
        } = this.props.finalizePurchase;

        return (
          this.renderSelectedPaymentModeWithLoading(
            isSelectedPaymentModeLoading,
            <div>
              <Form onSubmit={e => {
                e.preventDefault();
                this.props.handleSubmitUPI({
                  paymentOption: selectedPaymentOption,
                });
              }}>
                <FormFieldsWrapper>
                  <FormField label="Enter your Virtual Payment Address" errors={upiHandleError}>
                    <input
                      type="text"
                      autoFocus={true}
                      placeholder="aakash@icici"
                      value={upiHandle}
                      disabled={isUPIRequestSubmitted || isUPIRequestSubmitting}
                      onChange={e => this.props.handleChangeUPIHandle(e.target.value)}
                      />
                  </FormField>
                  { !isUPIRequestSubmitted ?
                    <FormField>
                      <input className="btn-block btn-green"
                        disabled={isUPIRequestSubmitting}
                        style={{ marginBottom: 7 }}
                        type="submit"
                        value="Verify" />
                      <div className="soft-half--ends">
                        <a href="https://www.instamojo.com/blog/how-to-make-payments-with-upi/" target="_blank" rel="noreferrer">How to use UPI?</a>
                      </div>
                      <TnCText />
                    </FormField> :
                    <FormField>
                      <input className="btn-block btn-green disabled"
                        disabled
                        value="Waiting..." />
                    </FormField>
                  }
                  { isUPIRequestSubmitted ?
                    <div className="center">
                      <img src={`${STATIC_URL}assets/images/payment/upi.png`} alt="upi" className="push--bottom"/>
                      <p className="push--bottom">Check your phone for verification notification from {upiBank}.</p>
                    </div> :
                    null
                  }
                </FormFieldsWrapper>
              </Form>
            </div>
          )
        );
      }

      case 'saved_cards': {
        return (
          this.renderSelectedPaymentModeWithLoading(
            isSelectedPaymentModeLoading,
            <div>
              <iframe
                className="animate-iframe--max-height"
                ref={(ref) => {this.scIframeRef = ref;}}
                src={`${selectedSavedCard.uri}?newWindow=${shouldSubmitInNewWindow}`}
                height={292}
                width="100%"
                frameBorder="0"
                scrolling="no">
              </iframe>
              <TnCText styles={termsTextStyles} />
            </div>
          )
        );
      }
    }
  }

  renderSelectedPaymentModeWrapper (selectedPaymentOption) {
    const { isSelectedPaymentModeLoading } = this.props.finalizePurchase;
    return (
      <div>
        { !isSelectedPaymentModeLoading ? (
          <div>
            <div className="soft--bottom">
              <span className="text-light-grey">{selectedPaymentOption.name}</span>
              <a
                className="right"
                onClick={() => this.props.handleResetSelectedPaymentMode()}>
                Change
              </a>
            </div>
          </div>
        ) : null}

        <div className="relative">
          {this.renderSelectedPaymentMode(selectedPaymentOption)}
          <TrustIcons />
        </div>
      </div>
    );
  }

  renderPaymentOption ({ name, type, submissionUri }) {
    return (
      <li key={name}>
      {
        submissionUri ?
        <a className="btn btn-block push--bottom text-left"
          onClick={() => this.props.handleSelectPaymentOption({ name, type })}>
          {
            name == 'UPI' ?
            <div>
              <img
                src="data:image/jpeg;base64,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"
                alt="upi" width="112px" />
            </div> :
            <div>
              {name}
            </div>
          }
        </a> :
        null
      }
      </li>
    );
  }

  renderPaymentOptions () {
    const { paymentOptions } = this.props.finalizePurchase;
    return (
      <ul className="push-half--top">
        { Object.keys(paymentOptions).map(optionKey =>
          this.renderPaymentOption(paymentOptions[optionKey])
        )}
      </ul>
    );
  }

  renderPromotionBanner () {
   const {
     wallet_wallets: {
       walletList,
     } = {},
   } = this.props.finalizePurchase.paymentOptions;
   const isFreeChargeEnabled = walletList ? walletList.filter(walletObject => walletObject.name == 'Freecharge').length == 1 : false;
   return isFreeChargeEnabled ? (
     <div
       className="soft--bottom text-green text-center"
       style={{ fontSize: '13px', lineHeight: '18px' }}>
       <div>Use FreeCharge Wallet & Get 10% cashback!</div>
       <a
         href="https://support.instamojo.com/hc/en-us/articles/211933269"
         style={{ color: '#2FBE6D' }}
         target="_blank" rel="noreferrer">
         <span style={{ borderBottom: '2px solid #2FBE6D' }}>Read More</span>
       </a>
     </div>
   ) : null;
  }

  render () {
    const {
      selectedPaymentMode,
      selectedPaymentObject,
      paymentOptions,
      gatewayDowntimeMessage,
      showTestTransactionAlert,
    } = this.props.finalizePurchase;

    return (
      <div>
        { selectedPaymentMode ?
          this.renderSelectedPaymentModeWrapper(selectedPaymentObject) :
          Object.keys(paymentOptions).length ?
            <div>
              { gatewayDowntimeMessage ?
                <div className="soft--bottom" style={{ borderBottom: '1px solid #eee' }}>
                  <Row>
                    <Columns className="small-2">
                      <i className="nc-icon-outline ui-3_alert red push-half--left" style={{ fontSize: '32px', marginTop: '18px' }}></i>
                    </Columns>
                    <Columns className="small-10">
                      <p style={{ fontSize: '14px' }}>{gatewayDowntimeMessage}</p>
                    </Columns>
                  </Row>
                </div> :
                null
              }
              { showTestTransactionAlert ?
                <div className="soft--bottom">
                  <Row className="soft--ends" style={{ background: '#2fbe6d' }}>
                    <Columns className="small-2">
                      <div style={{ transform: 'translatey(0px)', animation: 'float-animation 1s ease-in-out infinite', marginTop: '12px' }}>
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" enableBackground="new 0 0 32 32" xmlSpace="preserve"><g transform="translate(0, 0)"><path fill="#F9F936" d="M30.951,12.525c-0.118-0.362-0.431-0.626-0.807-0.681l-9.154-1.33L16.897,2.22
                        c-0.337-0.683-1.457-0.683-1.794,0l-4.093,8.294l-9.154,1.33c-0.376,0.055-0.689,0.319-0.807,0.681
                        c-0.118,0.362-0.02,0.759,0.253,1.025l6.624,6.456l-1.563,9.117c-0.064,0.375,0.09,0.754,0.398,0.978
                        c0.309,0.224,0.717,0.252,1.053,0.076L16,25.873l8.187,4.304c0.146,0.077,0.306,0.115,0.465,0.115c0.207,0,0.414-0.064,0.588-0.191
                        c0.308-0.224,0.462-0.603,0.398-0.978l-1.563-9.117l6.624-6.456C30.971,13.284,31.069,12.887,30.951,12.525z"></path></g></svg>
                      </div>
                    </Columns>
                    <Columns className="small-10">
                      <p style={{ fontSize: '14px', color: 'white' }}>Go ahead & complete this payment now! It will have NO charges. Full amount will come to your bank.</p>
                    </Columns>
                  </Row>
                </div> :
                null
              }
              { this.renderPromotionBanner() }

              <SavedCards
                savedCards={paymentOptions['saved_cards_savedcards']}
                {...this.props}
              />

              <p className={classNames('text-light-grey', gatewayDowntimeMessage ? 'soft--top' : null )}>Select a Payment Method</p>
              {this.renderPaymentOptions()}
              <ConvenienceFeeNote />
              <TrustIcons/>
            </div> :
            <p>Sorry, You can't pay for this. Email us at support@instamojo.com for further assistance.</p>
        }
      </div>
    );
  }
}

FinalizePurchase.propTypes = {
  isOpenable: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

FinalizePurchase.defaultProps = {
  isOpenable: true,
  isOpen: false,
  isAnimated: true,
  heading: 'Payment',
};

function mapStateToProps (state) {
  if (state.cart) {
    const { finalizePurchase } = state.cart;
    return {
      finalizePurchase,
      isMobileDevice: finalizePurchase.isMobileDevice,
    };
  }

  const {
    finalizePurchase,
    settings: {
      isMobileDevice,
      isRetrying,
      seller: {
        username,
      },
      isFinalizeFormOpen,
    },
    retry: {
      finalizePurchase: retryFinalizePurchase,
    } = {},
  } = state;
  return {
    finalizePurchase: isRetrying ? retryFinalizePurchase : finalizePurchase,
    isMobileDevice,
    username,
    isFinalizeFormOpen,
  };
}

export default connect(mapStateToProps, {
  handleResetSelectedPaymentMode,
  handleSelectPaymentOption,
  handleSelectBank,
  handleSelectWallet,
  handleBankPaymentRequest,
  handleWalletPaymentRequest,
  handleChangeEMICardProvider,
  handleChangeEMITenure,
  handleSubmitEMIForm,
  handleChangeSelectedEMIProvider,
  handleHideLoader,
  handleChangeUPIHandle,
  handleSubmitUPI,
  handleAwaitingPaymentCompletion,
})(scrollController(FinalizePurchase));



// WEBPACK FOOTER //
// ./src/payments/views/FinalizePurchase.js